import { LogLevel } from "@azure/msal-browser";
import { APIwithoutInterceptor } from "../Axios/Axios";
import { getAuthenticationConfig } from "../Helpers/APIEndpoints/Endpoints";

const response = await APIwithoutInterceptor.post(getAuthenticationConfig);

const data = await response.data;
const parsedAuthType = JSON.parse(data.data); // Parse the JSON string

export const msalConfig = {
    auth: {
        clientId: parsedAuthType.clientId,
        authority: `${parsedAuthType.authority}${parsedAuthType.tenantId}`,
        redirectUri: parsedAuthType.redirectUri,
        postLogoutRedirectUri: "/",
    },
    cache: {
        cacheLocation: "sessionStorage", // or "sessionStorage"
        storeAuthStateInCookie: false, // Set to true if you need to support IE11
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                         
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            logLevel: LogLevel.Info,
        },
    },
};

export const loginRequest = {
    scopes: ["user.read", "openid", "profile", "email"],
};
